import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const LeaderAd = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px 0;
    z-index: 1;
`;

export const TakeoverAd = styled.div`
    height: 1px;
    width: 1px;
`;

export const MRecAd = styled.div`
    display: none;

    ${BaseStyle.Mixins.screenSizes.large} {
        display: block;
    }
`;
